import { useContext } from "~/stores/context.js";

export default defineNuxtRouteMiddleware(async () => {
  const context = useContext();

  const { $i18n } = useNuxtApp();

  await $i18n.setLocale(context.locale);
});
